
import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";



export const v3_project_wise_document_count = async (page, limit, payload) => {
    const url = `/v3/document/project/${page}/${limit}?payload=${payload}`; // No need for full base URL, it's handled
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};



export const v3_ship_wise_document_count = async (projectId) => {
    const url = `/v3/document/ship/${projectId}`;
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};



export const v3_add_document = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_document = async (documentId, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document/${documentId}`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_upload_document = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document/file`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_save_document_file = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document/files`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_ship_wise_document_list = async (shipId, payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document/files/${shipId}${payload ? `?payload=${payload}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_add_document_comment = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/document/comment`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
